module.exports = __webpack_public_path__ + "static/img/ww04.3e3e14d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ww04.png
// module id = ksOy
// module chunks = 0